import {useLocation, useNavigate} from "react-router-dom";
import {Box, Center, CloseButton, Container, Group, LoadingOverlay, Paper, Space, Title} from "@mantine/core";
import {ContainerExportOptions, getRequiredObjectId} from "@ots-frontend/ots-data";
import {useTranslation} from "react-i18next";
import {useCallback} from "react";
import {
  ContainerExportForm,
  ContainerExportFormDefaultValues,
  ContainerExportFormValues
} from "../../components/form/ContainerExportForm/ContainerExportForm";
import {ThemedPage} from "../../components/page/ThemedPage/ThemedPage";
import {useApp} from "../../providers/RegionProvider/RegionProvider";
import {useDownloadContainerExport} from "../../hooks/useDownloadContainerExport";

type Props = {
  formDefaults?: ContainerExportFormDefaultValues
}

export const ContainerExportFormPageRoute = () => {
  const {state} = useLocation();
  const formDefaults = state?.formDefaults;
  return (
    <ContainerExportFormPage
      formDefaults={formDefaults}
    />
  );
};

export const ContainerExportFormPage = (props: Props) => {
  const {
    formDefaults,
  } = props;

  const {baseQueryApi, regionId} = useApp()

  const navigate = useNavigate();
  const {t} = useTranslation(["common"]);

  const {
    downloadContainerExport,
    downloading,
  } = useDownloadContainerExport({baseQueryApi: baseQueryApi})

  const onContainerExportSubmit = useCallback((formValues: ContainerExportFormValues) => {
    const options: ContainerExportOptions = {
      companyIds: formValues.companies?.map(getRequiredObjectId),
      wellMappingKey: formValues.wellMappingKey,
      containerMappingKey: formValues.containerMappingKey,
      containerMappingKey2: formValues.containerMappingKey2,
      regionIds: regionId ? [regionId] : undefined
    }

    downloadContainerExport(options, () => {
      navigate(-1)
    })

  }, [downloadContainerExport, navigate, regionId]);

  return (
    <ThemedPage>
      {(classes) => (
        <Container className={classes.container} fluid={true} py="md">
          <Center>
            <Paper miw={500} shadow="sm" p="md" py="md">
              <Box pos="relative">
                <LoadingOverlay visible={downloading}/>
                <Group position="apart">
                  <Title align="center">
                    {t("common.page.entity.container.export.form.title", "Export Containers", {ns: "common"})}
                  </Title>
                  <CloseButton title="Close" size="xl" iconSize={20} onClick={() => navigate(-1)}/>
                </Group>
                <Space h="md"/>
                <ContainerExportForm
                  options={{
                    regionId: regionId,
                  }}
                  defaultValues={formDefaults}
                  submitting={downloading}
                  onSubmit={onContainerExportSubmit}/>
              </Box>
            </Paper>
          </Center>
        </Container>
      )}
    </ThemedPage>
  );
};
